import {
  BaseComponent,
  environment,
  ChangeMapPopupStatus,
  ChangeadrsDetailsPopupStatus,
  ChangeTempToDeliveryAddress,
  UpdateAddressList,
  DeleteDeliveryAddress,
  FetchAddressList,
  AddressState,
  Address,
  SweetAlertService,
  LocationState,
  FetchDeliveryAddressDetails,
  FetchCartMenuItems,
  UpdateDeliverableStatus,
} from '@moduurnv2/libs-orderingapp/src/core';
import { Observable } from 'rxjs/internal/Observable';
import { Input, OnInit } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import {
  ChangeDeliveryAddress,
  ChangeDeliveryAddressLocal,
  AuthState,
  FetchMenuList,
} from '@moduurnv2/libs-orderingapp/src/core';
import { ChangePopupStatus } from '@moduurnv2/libs-orderingapp/src/core';
import { takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ModalService } from '@moduurnv2/web/features/ui/components/modal/modal.service';

export class AddressCardBaseComponent extends BaseComponent implements OnInit {
  @Input('items') items: any;
  @Input() isAddressBook: boolean;
  @Select(AddressState.getDeliveryAddress) DeliveryAddress$: Observable<
    Address
  >;
  imgBasePath: string = environment.image_basepath;
  icon = {
    location: this.imgBasePath + environment.images.location,
    edit: this.imgBasePath + environment.images.edit,
    remove: this.imgBasePath + environment.images.close,
    selected: this.imgBasePath + environment.images.success,
  };
  selectedAdrs: string;
  addressList: any;
  selectedLoc: Address;
  distance: string;
  isShowDiv: boolean = true;
  ngOnInit() {
    this.subscribeAdrs();
  }
  constructor(
    public store: Store,
    public sweetAlert: SweetAlertService,
    private httpresult: HttpClient,
    public modal: ModalService
  ) {
    super();
  }
  selectAdress(_id) {
    if (this.isAddressBook) {
      this.toggleDisplayDiv();
    } else {
      let customer = this.store.selectSnapshot(AuthState.getCommonAuthDetails);
      if (customer && customer.customerId) {
        this.store.dispatch(new ChangeDeliveryAddress(_id));
      } else {
        this.store.dispatch(new ChangeDeliveryAddressLocal(_id));
      }
      // this.vm.store.dispatch(new ChangePopupStatus(false));
      this.selectedAdrs = _id;
      this.store.dispatch(new FetchMenuList());
      this.store.dispatch(new FetchCartMenuItems({}));
      this.store.dispatch(new UpdateDeliverableStatus(true));
    }
  }
  removeAdrs(_id) {
    this.sweetAlert
      .confirmDelete(
        'Are you sure you want to delete this address?',
        'Address once deleted cannot be undone.'
      )
      .then((choice) => {
        if (choice) {
          let customer = this.store.selectSnapshot(
            AuthState.getCommonAuthDetails
          );
          if (customer && customer.customerId) {
            this.store
              .dispatch(new DeleteDeliveryAddress(_id))
              .subscribe((data) => {
                this.store.dispatch(new FetchAddressList());
              });
          } else {
            let locations = JSON.parse(localStorage.getItem('locationList'));
            let index = locations.findIndex((adrs) => adrs._id == _id);
            locations.splice(index, 1);
            localStorage.setItem('locationList', JSON.stringify(locations));
            this.store.dispatch(new UpdateAddressList(locations));
          }
          if (this.selectedLoc._id == _id) {
            localStorage.setItem('selectedAdrsLocation', undefined);
          }
        }
      });
  }
  editAdrs(_id) {
    this.store.dispatch(new ChangeadrsDetailsPopupStatus(true));
    this.store.dispatch(new ChangeMapPopupStatus(true));
    let customer = this.store.selectSnapshot(AuthState.getCommonAuthDetails);
    if (customer && customer.customerId) {
      let locations = this.store.selectSnapshot(AddressState.getAddressList);
      let location = locations.find((adrs) => adrs._id == _id);
      localStorage.setItem(
        'tempSelectedAdrsLocation',
        JSON.stringify(location)
      );
    } else {
      let locations = JSON.parse(localStorage.getItem('locationList'));
      let location = locations.find((adrs) => adrs._id == _id);
      localStorage.setItem(
        'tempSelectedAdrsLocation',
        JSON.stringify(location)
      );
      this.store.dispatch(new ChangeTempToDeliveryAddress(location));
    }
  }
  subscribeAdrs() {
    this.DeliveryAddress$.pipe(takeUntil(this.destroy$)).subscribe(
      (address) => {
        this.selectedLoc = address;
      }
    );
  }
  toggleDisplayDiv() {
    this.isShowDiv = !this.isShowDiv;
  }
}
